module.exports = __webpack_public_path__ + "img/上海理工大学.77cb793c.png";